function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M160-785.615v-12.769a1.556 1.556 0 0 1 .475-1.141 1.556 1.556 0 0 1 1.141-.474h12.769a1.556 1.556 0 0 1 1.141.474 1.556 1.556 0 0 1 .475 1.141v12.769a1.556 1.556 0 0 1-.475 1.141 1.556 1.556 0 0 1-1.141.474h-12.769a1.556 1.556 0 0 1-1.141-.474 1.556 1.556 0 0 1-.475-1.141zm1-9.231h14v-3.538a.6.6 0 0 0-.173-.443.6.6 0 0 0-.443-.173h-12.768a.6.6 0 0 0-.443.173.6.6 0 0 0-.173.443zm5 4.923h4v-3.923h-4zm0 4.923h4v-3.923h-4zm-5-4.923h4v-3.923h-4zm10 0h4v-3.923h-4zM161.616-785H165v-3.923h-4v3.307a.6.6 0 0 0 .173.443.6.6 0 0 0 .443.173zm9.384 0h3.382a.6.6 0 0 0 .443-.173.6.6 0 0 0 .173-.443v-3.307h-4z",
    transform: "translate(-160 800)",
    style: {
      fill: "#196cca"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.4c927b8894e38cc62d844ef17e5f98db.svg";
export { ForwardRef as ReactComponent };